import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon, library } from '@fortawesome/fontawesome-svg-core';
import { useLocation } from '@reach/router';
import * as icons from '../../icons/icon-pack';
import { extractLanguage } from '../../helpers/common';

export default function ServicesTiles({ blok }) {
  const { section_orientation: sectionOrientation } = blok;

  library.add({ ...icons });

  const styles = clsx(
    sectionOrientation === 'vertical'
      ? 'flex flex-wrap xl:flex-nowrap gap-0 lg:gap-20 lg:!flex-wrap xl:!flex-nowrap flex-column px-4 lg:px-16 items-center'
      : 'px-4 lg:px-16 ',
  );

  const tilesContainerStyle = clsx(
    sectionOrientation === 'vertical'
      ? 'grid gap-4 grid-cols-2 lg:grid-cols-3 xl:w-2/3'
      : 'grid gap-4 grid-cols-2 lg:grid-cols-4 pt-2 ',
  );

  const location = useLocation();

  const currentLanguage = extractLanguage(location.pathname);

  return (
    <div {...storyblokEditable(blok)} className={`${styles} w-full homepage-service-tiles`}>
      {blok?.blocks?.map((block) => (
        <StoryblokComponent
          blok={block}
          key={block._uid}
          className="m-auto w-full"
        />
      ))}
      <div className={`${tilesContainerStyle} w-full`}>
        {blok?.tile?.map((item, index) => {
          let prefix;
          let iconName;

          if (item?.icon) {
            iconName = item?.icon;
            prefix = 'far';
          }

          const perkIcon = icon({ prefix, iconName });

          return (
            <div
              key={item.title}
              className={`${
                index > 4 ? 'hidden lg:block' : ''
              }`}
            >
              <Link
                to={`/${item.url.story.full_slug}`}
                className="flex relative gap-4 flex-col justify-center items-center h-48 bg-green-800 hover:bg-green-900"
                key={item.title}
              >
                <FontAwesomeIcon
                  icon={perkIcon}
                  size="2x"
                  className="text-white"
                />
                <h4 className="text-lg w-full text-center break-words px-2 text-white">{item.title}</h4>
              </Link>
            </div>
          );
        })}
        {blok?.showmore_tile && (
          <Link
            to={currentLanguage === 'en' ? '/en/services' : '/services'}
            className="flex p-12 bg-green-800 hover:bg-green-900 text-white group"
          >
            <div className="flex m-auto items-center group-hover:scale-105 transition-transform">
              <span className="mr-2">
                {currentLanguage === 'default' ? 'Mehr' : 'More'}
              </span>
              <FontAwesomeIcon
                icon={icon({ prefix: 'far', iconName: 'arrow-right' })}
                size="2x"
              />
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
